<div class="input">
    <div class="label-title"
        >Generate report</div>
    <p-dropdown (onChange)="onBuildSchedule()"
                [options]="options"
                [(ngModel)]="selectedOption"
                [disabled]="options.length === 1"></p-dropdown>
    <div class="label-title"
         *ngIf="selectedOption && selectedOption.subLabel">{{selectedOption.subLabel}}</div>
</div>
<div *ngIf="showMonthlyTimeFrames">
    <div class="input">
        <div class="label-title">Time Range</div>
        <p-dropdown [options]="monthlyTimeFrames" [(ngModel)]="monthSelected" (onChange)="onBuildSchedule()"></p-dropdown>
    </div>
</div>
<div *ngIf="!showMonthlyTimeFrames">
    <div class="input" *ngIf="selectedOption && selectedOption.key === 'monthly'">
        <div class="label-title">on this day of the month&nbsp;<span class="material-icons" pTooltip="If a month has fewer days, the last day of the month is used.">info</span></div>
        <p-dropdown (onChange)="onBuildSchedule()"
                    [options]="dayOfMonth"
                    [(ngModel)]="scheduledDayOfMonth">
        </p-dropdown>
    </div>
    <div class="input" *ngIf="selectedOption && selectedOption.key === 'weekly'">
        <div class="label-title">on this day</div>
        <p-dropdown (onChange)="onBuildSchedule()"
                    [options]="dayOfWeek"
                    [(ngModel)]="scheduledDayOfWeek">
        </p-dropdown>
    </div>
    <div class="input md-inputfield">
        <div class="label-title">
            <span>{{ (selectedOption && selectedOption.hourInputLabel) ? selectedOption.hourInputLabel : 'generate at this local time' }}
                <span *ngIf="minDate">&nbsp;between {{ minDate | date:'HH:mm' }} - {{ maxDate | date:'HH:mm' }}&nbsp;
                    <span class="material-icons" pTooltip="Schedule times are limited to avoid incomplete reports.">info</span>
                </span>
            </span>
            *
        </div>
        <p-calendar [(ngModel)]="hourSelected"
                    [ngClass]="{ 'invalid': isInvalidDate }"
                    [timeOnly]="true"
                    [showTime]="true"
                    hourFormat="24"
                    (onInput)="onBuildSchedule()"
                    (onBlur)="onBuildSchedule()"></p-calendar>
        <small *ngIf="isInvalidDate" class="ui-message ui-messages-error ui-corner-all">Select a valid time.</small>
    </div>
</div>
